import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import { Grid, Form, Container, Button, Divider, Input, Image, FormGroup } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import axios from 'axios';

import { API_GATEWAY_URL, SECONDARY_COLOR_CODE, PRIMARY_COLOR } from '../../../constants/config';

class Layout extends Component {
  static get propTypes() {
    return {
      refUrl: PropTypes.string,
    };
  }

  static get defaultProps() {
    return {
      refUrl: '',
    };
  }

  constructor(props) {
    super(props);

    this.state = {
      email: '',
      password: '',
      verifyPassword: '',
      otpCode: '',
      verified: false,
      reseted: false,
      error: false,
      loading: false,
      messages: [],
    };

    this.onChange = this.onChange.bind(this);
    this.onVerify = this.onVerify.bind(this);
    this.onResetPassword = this.onResetPassword.bind(this);
  }

  onChange(event, data) {
    event.preventDefault();

    const { name, value } = data;
    this.setState({ [name]: value });
  }

  async onVerify(e) {
    e.preventDefault();

    this.setState({
      loading: true,
    });

    const email = this.state.email.trim().toLowerCase();

    if (!email) {
      this.setState({
        loading: false,
        error: true,
        messages: 'Vui lòng nhập email.', // TODO: change to i18n
      });

      return;
    }

    try {
      await axios({
        method: 'POST',
        data: { email },
        url: `${API_GATEWAY_URL}/v1/users/verifyEmail`,
      });
      
      this.setState({
        loading: false,
        error: false,
        verified: true,
      });
    } catch (error) {    
      this.setState({
        loading: false,
        error: true,
        messages: error.response.data.error.message, // TODO: change to i18n
      });
    }
  }

  async onResetPassword(e) {
    e.preventDefault();

    this.setState({
      loading: true,
    });

    const email = this.state.email.trim().toLowerCase();
    const password = this.state.password.trim();
    const verifyPassword = this.state.verifyPassword.trim();
    const otpCode = this.state.otpCode.trim();

    if (!email) {
      this.setState({
        loading: false,
        error: true,
        messages: 'Vui lòng nhập email.', // TODO: change to i18n
      });

      return;
    }

    if (!password || !verifyPassword || !otpCode) {
      this.setState({
        loading: false,
        error: true,
        messages: 'Vui lòng nhập đầy đủ mật khẩu & mã xác thực.', // TODO: change to i18n
      });

      return;
    }

    try {
      await axios({
        method: 'POST',
        data: { credentials: {
          email,
          otpCode,
          password,
        } },
        url: `${API_GATEWAY_URL}/v1/users/resetPassword`,
      });
      
      this.setState({
        loading: false,
        error: false,
        reseted: true,
        verified: false,
        email: '',
        password: '',
        verifyPassword: '',
        otpCode: '',
      });

    } catch (error) {    
      this.setState({
        loading: false,
        error: true,
        messages: error.response.data.error.message, // TODO: change to i18n
      });
    }
  }

  render() {
    const {
      verified, reseted, otpCode,
      email, password, verifyPassword,
      loading, error, messages,
    } = this.state;
    console.log('email: ', email);

    return (
      <div className="login-form">
        <style>
          {`
            body > div,
            body > div > div,
            body > div > div > div.login-form {
              height: 100%;
            }

            body {
              background-image: url("images/background.jpg");
              background-position: center;
              background-repeat: no-repeat;
              background-size: cover;
            }
        `}
        </style>
        <Grid textAlign="center" style={{ height: '100%' }} verticalAlign="middle" >
          <Grid.Column style={{ position: 'absolute', top: '50%', left: '50%', marginLeft: '-225px', marginTop: '-300px', width: '450px', overflow: 'hidden', background: 'rgb(255,255,255,0.7)', borderRadius: '0.3em', paddingRight: '1em !important' }}>
            <Grid centered textAlign="center" className="logo">
              <Image src="/images/adg-logo.png" alt="logo" style={{ maxWidth: 700, maxHeight: 110 }} />
              <div style={{ fontSize: '22px', fontWeight: 'bold', textTransform: 'uppercase', lineHeight: '32px', color: '#372d73', whiteSpace: 'pre-line' }}>Quên mật khẩu</div>
            </Grid>
            <Divider hidden />

            { verified &&
              <Form className="attached fluid segment login" style={{ backgroundColor: 'transparent', border: 'none' }}>
                <Form.Field control={Input} name="password" value={password} onChange={this.onChange} fluid icon="lock" placeholder="Mật khẩu" type="password" />
                <Form.Field control={Input} name="verifyPassword" value={verifyPassword} onChange={this.onChange} fluid icon="lock" placeholder="Nhập lại mật khẩu" type="password" />
                <FormGroup widths='equal'>
                  <Form.Field control={Input} name="otpCode" value={otpCode} onChange={this.onChange} fluid placeholder="Mã OTP" />
                  <Button color='blue' circular icon="undo" style={{marginTop: '-5px' }} />
                </FormGroup>
                <Container textAlign="center">
                  <Button type="button" onClick={this.onResetPassword} loading={loading} name="verify">Cập nhật</Button>                
                </Container>
              </Form>        
            }

            { !verified && !reseted &&
              <Form className="attached fluid segment login" style={{ backgroundColor: 'transparent', border: 'none' }}>
                <Form className="attached fluid segment login" style={{ backgroundColor: 'transparent', border: 'none' }}>
                  <Form.Field control={Input} name="email" value={email} onChange={this.onChange} fluid icon="mail" placeholder="Email" />              
                  <Container textAlign="center">
                    <Button type="button" onClick={this.onVerify} loading={loading} name="verify">Tiếp tục</Button>                
                  </Container>
                </Form>
              </Form>
            }

            { reseted && <p style={{ color: 'green', margin: '0 0 2rem 0', fontWeight: 'bold' }}>Quý khách đã đổi mật khẩu thành công</p>}
            <p style={{ color: SECONDARY_COLOR_CODE, fontWeight: 'bold' }}>{error ? messages : ''}</p>
            <Link
                to='/login/'
                style={{fontWeight: 'bold', color: '#372d73'}}
              >
                <b>Quay lại đăng nhập</b>
              </Link>
            <Divider hidden style={{ height: '40px' }} />

            <span style={{ color: '#000' }}>Bản quyền © bởi TSC Services.</span>
          </Grid.Column>
        </Grid>
      </div>
    );
  }
}

export default withRouter(Layout);
